/**
 * Formats time in seconds to a human-readable string with minutes and seconds
 * @param seconds Total number of seconds
 * @param t Translation function
 * @returns Formatted string like "2 minutes and 30 seconds" or "45 seconds"
 */
export function formatTimeLeft(
  seconds: number,
  t: (key: string) => string
): string {
  if (seconds <= 60) {
    return `${seconds} ${t('seconds')}`
  }

  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  return `${minutes} ${t('minutes')} ${t('and')} ${remainingSeconds} ${t(
    'seconds'
  )}`
}
